module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('footer', {
    staticClass: "hero-foot"
  }, [_h('div', {
    staticClass: "container has-text-centered"
  }, [_h('p', {
    staticClass: "express-condolence"
  }, ["\n      In Remembrance of His Majesty", _h('br'), " ", _h('span', {
    staticClass: "big-font"
  }, ["King Bhumibol Adulyadej"])]), " ", _h('div', {
    staticClass: "share-container"
  }, [_h('div', {
    staticClass: "fb-share-button share-button",
    attrs: {
      "data-href": "https://grief2grace.firebaseapp.com",
      "data-layout": "button_count",
      "data-size": "small",
      "data-mobile-iframe": "false"
    }
  }, [_h('a', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fgrief2grace.firebaseapp.com%2F&src=sdkpreparse"
    }
  }, ["Share"])]), " ", _h('a', {
    staticClass: "twitter-share-button",
    attrs: {
      "href": "https://grief2grace.firebaseapp.com"
    }
  }, ["\n      Tweet"]), " ", _h('div', {
    staticClass: "line-it-button share-button",
    attrs: {
      "style": "display: none;",
      "data-type": "share-a",
      "data-lang": "en"
    }
  })])])])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49ec9b6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer-comp.vue
// module id = 124
// module chunks = 2